import { isObject } from 'lodash';

var transText = function transText(value, defaultValue) {
  var _a;
  if (defaultValue === void 0) {
    defaultValue = '-';
  }
  if (isObject(value)) {
    return (_a = value === null || value === void 0 ? void 0 : value.text) !== null && _a !== void 0 ? _a : defaultValue;
  }
  return value !== null && value !== void 0 ? value : defaultValue;
};

export { transText as default };
